<template>
    <div class="s_c999 mb10"><span class="s_c333">活动码总数:</span>{{total}}</div>
    <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='rangeList' :scroll="{ x: 'max-content'}">
      <template v-slot:action="{ record }">
        <a-popconfirm title="确定要删除该活动么？" @confirm="del(record)" ok-text="删除" cancel-text="取消" placement="topRight">
          <a-button type="danger" size="small" href="javascript:;">删除</a-button>
        </a-popconfirm>
      </template>
    </a-table>
</template>

<script>
let columns = [
  {
    title: "批次",
    dataIndex: "batch_sn",
    key: "batch_sn",
  },
  {
    title: "起始流水号",
    dataIndex: "small_serial_start",
    key: "small_serial_start",
  },
  {
    title: "结束流水号",
    key: "small_serial_end",
    dataIndex: "small_serial_end",
  },
  {
    title: "区间数量",
    dataIndex: "small_code_counts",
    key: "small_code_counts",
  },
  {
    title: "备注",
    dataIndex: "remarks",
    key: "remarks",
  },
];
export default {
  props:{
      rangeList:Array,
      total:Number
  },
  setup(){
   return{
     columns
   }
  }
}
</script>